"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.qrcodeCreateApi = qrcodeCreateApi;
exports.qrcodeDeleteApi = qrcodeDeleteApi;
exports.qrcodeDetailApi = qrcodeDetailApi;
exports.qrcodeListApi = qrcodeListApi;
exports.qrcodeUpdateApi = qrcodeUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 客服二维码列表
 * @param params
 */
function qrcodeListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/qrcode/popup/page',
    method: 'GET',
    params: params
  });
}

/**
 * 新增客服二维码
 * @param data
 */
function qrcodeCreateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/qrcode/popup/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑客服二维码
 * @param data
 */
function qrcodeUpdateApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/qrcode/popup/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除客服二维码
 */
function qrcodeDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/qrcode/popup/delete/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 客服二维码详情
 * @param id
 */
function qrcodeDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/qrcode/popup/detail/".concat(id),
    method: 'GET'
  });
}